__turbopack_context__.v({
  "className": "dm_sans_d583a617-module__574PkW__className",
});
